import RemoveLibraryFontEvent, { RemoveLibraryFontEventType } from '@adobe-fonts/site/events/RemoveLibraryFontEvent.js';
import DeleteLibraryEvent, { DeleteLibraryEventType } from '@adobe-fonts/site/events/DeleteLibraryEvent.js';

export function registerEventHandlers(element) {
  element.addEventListener(RemoveLibraryFontEvent.EVENT_NAME, handleRemoveLibraryFontEvent);
  element.addEventListener(DeleteLibraryEvent.EVENT_NAME, handleDeleteLibraryEvent);
}

function handleRemoveLibraryFontEvent(event) {
  const { detail: { type, libraryElementIds } } = event;

  const showCard = type === RemoveLibraryFontEventType.Restore;

  for (const libraryElementId of libraryElementIds) {
    const libraryElement = document.querySelector(`af-variation-card[data-element-id="${libraryElementId}"]`);
    if (libraryElement) {
      libraryElement.style.display = showCard ? 'block' : 'none';
    }
  }
}

// Matches TIMEOUT_WITH_LINK_MS in app/assets/javascripts/spectrum/services/notification_service.js
const DELETE_LIBRARY_TIMEOUT = 5000;
let redirectTimeout = null;

// Redirect to the libraries page after a library is deleted, unless it is restored
function handleDeleteLibraryEvent(event) {
  const { detail: { type } } = event;

  if (type === DeleteLibraryEventType.Delete) {
    redirectTimeout = setTimeout(() => {
      window.location.href = '/libraries';
    }, DELETE_LIBRARY_TIMEOUT);
  } else if (type === DeleteLibraryEventType.Restore && redirectTimeout) {
    clearTimeout(redirectTimeout);
  }
}
